<template>
  <div>
    <vs-row>
      <vs-col class="lg:w-3/5 p-base flex flex-col justify-between">
        <div>
          <div
            class="p-5 mb-base items-center"
            :style="{ background: currentBoard.backgroundColor }"
            style="width: fit-content; border-radius: 8px"
          >
            <img :src="currentBoard.icon" width="70px" />
          </div>
          <h2 class="mb-3">{{ currentBoard.title }}</h2>
          <p class="mb-base">{{ currentBoard.description }}</p>
        </div>
        <div class="vx-card__footer">
          <vs-button
            class="w-full use-template-btn py-4"
            color="primary"
            @click.prevent="createBoard"
            >Use this Template</vs-button
          >
        </div>
      </vs-col>
      <vs-col class="lg:w-2/5 p-base" style="background-color: #f1f1f1">
        <h4 class="mb-5">Board Configuration</h4>
        <p class="mb-5">APPS ON BOARD</p>
        <div class="mb-4">
          <vs-row
            v-for="(da, index) in currentBoard.defaultApps"
            :key="index"
            class="mb-3"
            vs-type="flex"
            vs-justify="space-between"
          >
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
              <div style="display: flex; align-items: center">
                <span
                  class="template-options-btn-icon inline-flex feather-icon text-primary mr-3"
                >
                  <img
                    :src="getAppDataById(da).icon"
                    width="30px"
                    height="30px"
                  />
                </span>
                <h5 v-if="orgData.slug === 'gala' && da === 'coach'">Mentor</h5>
                <h5 v-else-if="orgData.slug !== 'gala' && da === 'coach'">
                  Coach
                </h5>

                <h5 v-else>{{ getAppDataById(da).title }}</h5>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="4">
              <div style="display: flex; align-items: center">
                <feather-icon
                  icon="CheckCircleIcon"
                  svgClasses="text-success w-7 h-7"
                  class="mr-3"
                />
                <p>Included</p>
              </div>
            </vs-col>
          </vs-row>

          <vs-row
            v-for="(da, index) in currentBoard.optionalApps"
            :key="index"
            class="mb-3"
            vs-type="flex"
            vs-justify="space-between"
          >
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="7">
              <div style="display: flex; align-items: center">
                <span
                  class="template-options-btn-icon inline-flex feather-icon text-primary mr-3"
                >
                  <img
                    :src="getAppDataById(da).icon"
                    width="30px"
                    height="30px"
                  />
                </span>
                <h5 v-if="orgData.slug === 'gala' && da === 'coach'">Mentor</h5>
                <h5 v-else-if="orgData.slug !== 'gala' && da === 'coach'">
                  Coach
                </h5>

                <h5 v-else>{{ getAppDataById(da).title }}</h5>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import boardTemplates from "@/assets/data/board-templates.js";
import marketplaceList from "@/assets/data/marketplace-list.js";

export default {
  props: ["boardId"],
  data() {
    return {
      boardTemplates,
      marketplaceList,
    };
  },
  computed: {
    currentBoard() {
      const boardIndex = this.boardTemplates.findIndex((board) => {
        return board.id === this.boardId;
      });
      if (boardIndex !== -1) return this.boardTemplates[boardIndex];
      else return {};
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  methods: {
    generateBoardSlug(boardTitle) {
      let slug = "default";
      if (boardTitle) {
        let r = (Math.random() + 1).toString(36).substring(3);
        slug =
          boardTitle
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "-" +
          r;
      }
      return slug;
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    createBoard() {
      let installedApps = [...this.currentBoard.defaultApps];

      if (this.currentBoard && this.currentBoard.optionalApps) {
        installedApps = [
          ...this.currentBoard.defaultApps,
          ...this.currentBoard.optionalApps,
        ];
      }

      const payload = {
        boardId: this.boardId,
        userId: this.userData._id,
        organizationId: this.orgData._id,
        numberOfUsers: 1,
        installedApps,
        paymentStatus: "pending",
        status: "draft",
        slug: this.generateBoardSlug("default-title"), // temporary
      };

      // console.log(payload);

      this.$store
        .dispatch("boards/createBoard", payload)
        .then(async (res) => {
          await this.$emit("close-board-details-popup");
          this.$router.push({
            name: "org-board-checkout",
            params: { boardId: res.data._id },
          });
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>

<style scoped>
.con-vs-popup >>> .vs-popup--contentt {
  padding: 0 !important;
  margin: 0 !important;
}

.use-template-btn {
  border-radius: 8px;
}

.included-apps {
  display: flex;
  align-content: space-between;
}
</style>
